import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Tabs, Tab } from '@mui/material';
import PropertiesPanelV2 from './PropertiesPanelV2';
import LayersPanel from './LayersPanel';
import AnimationsPanel from './AnimationsPanel';

/**
 * Right Sidebar - Properties and Layers/Animations tabs
 * Shows Animations tab when designMode is 'video', Layers tab when 'image'
 */
const RightSidebar = () => {
  const { designMode } = useSelector((state) => state.canvas);
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box
      sx={{
        width: 320,
        backgroundColor: 'white',
        borderLeft: '1px solid #E0E0E0',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Tabs */}
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => setActiveTab(newValue)}
        variant="fullWidth"
        sx={{
          backgroundColor: '#F5F5F5',
          padding: '8px',
          borderRadius: '12px',
          margin: '16px',
          minHeight: 'auto',
          '& .MuiTabs-indicator': {
            display: 'none',
          },
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 500,
            fontSize: '14px',
            minHeight: 'auto',
            padding: '8px 16px',
            borderRadius: '8px',
            color: '#666',
            transition: 'all 0.2s',
            '&.Mui-selected': {
              backgroundColor: 'white',
              color: '#000',
              fontWeight: 600,
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            },
          },
        }}
      >
        <Tab label="Properties" />
        <Tab label={'Layers'} />
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ flex: 1, overflow: 'auto' }}>
        {activeTab === 0 && <PropertiesPanelV2 />}
        {activeTab === 1 && (
        //   designMode === 'video' ? <AnimationsPanel /> :
           <LayersPanel />
        )}
      </Box>
    </Box>
  );
};

export default RightSidebar;

